import {ErrorWithRetry} from '@github-ui/error-with-retry'
import {StopIcon, XIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'

import {BUTTON_LABELS} from '../../constants/buttons'
import {MESSAGES} from '../../constants/messages'
import styles from './IssueViewerError.module.css'

const GenericError = ({retry}: {retry: () => void}) => (
  <ErrorWithRetry message={MESSAGES.couldNotLoad} retry={retry} className={styles.ErrorWithRetry} />
)

export const NotFoundError = ({onClose}: {onClose?: () => void}) => (
  <div className={styles.notFoundContainer}>
    <Octicon size="medium" icon={StopIcon} className={styles.errorIcon} />
    <div className={styles.errorMessageContainer}>
      <h2>{MESSAGES.issueNotFound}</h2>
      <span className={styles.descriptionText}>{MESSAGES.issueNotFoundDescription}</span>
    </div>
    {onClose && (
      <div className={styles.closeButtonContainer}>
        <IconButton variant="invisible" aria-label={BUTTON_LABELS.closePanel} icon={XIcon} onClick={onClose} />
      </div>
    )}
  </div>
)

export const renderGenericError = (retry: () => void) => <GenericError retry={retry} />

export const renderIssueViewerErrors = (retry: () => void, error: Error, onClose?: () => void) => {
  if (error.message.includes('NOT_FOUND')) {
    return <NotFoundError onClose={onClose} />
  }

  return renderGenericError(retry)
}
